import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bf-modal bf-modal--has-sections bf-modal-course-detail"
}
const _hoisted_2 = { class: "bf-modal__section bf-bg-primary" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script mb-3" }, "Kursinformationen", -1)
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 col-lg-6" }
const _hoisted_10 = { class: "bf-modal-course-detail__name" }
const _hoisted_11 = { class: "me-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle",
  "aria-label": 'Kursbeschreibung'
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Kursbeschreibung", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "bf-modal-course-detail__horizontal-divider mx-2" }, "–", -1)
const _hoisted_17 = { class: "bf-modal-course-detail__mode text-nowrap" }
const _hoisted_18 = { class: "bf-modal-course-detail__appointment" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-calendar-check" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "bf-modal-course-detail__start"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", null, "Kursstart:", -1)
const _hoisted_22 = {
  key: 1,
  class: "bf-modal-course-detail__appointments"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-spinner fa-spin" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Lade Kurstermine ... ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "bf-modal-course-detail__horizontal-divider mx-2" }, "–", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_27 = {
  key: 2,
  class: "pb-3"
}
const _hoisted_28 = {
  key: 2,
  class: "bf-modal-course-detail__enrollment_deadline"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("b", null, "Anmeldefrist:", -1)
const _hoisted_30 = {
  key: 3,
  class: "bf-modal-course-detail__withdrawal_deadline"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("b", null, "Abmeldefrist:", -1)
const _hoisted_32 = { class: "col-12 col-lg-6" }
const _hoisted_33 = {
  key: 0,
  class: "bf-modal-course-detail__fee"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("b", null, "Einmalige Kursgebühr:", -1)
const _hoisted_35 = {
  key: 1,
  class: "bf-modal-course-detail__location"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("b", null, "Trainingsort:", -1)
const _hoisted_37 = { class: "bf-modal-course-detail__gathering" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("b", null, "Treffpunkt:", -1)
const _hoisted_39 = {
  key: 2,
  class: "bf-modal-course-detail__bringalong"
}
const _hoisted_40 = {
  key: 0,
  class: "col-12"
}
const _hoisted_41 = { class: "bf-modal-course-detail__info_text" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("b", null, "Kursinfo:", -1)
const _hoisted_43 = { class: "bf-modal__section" }
const _hoisted_44 = { class: "small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!
  const _component_CourseSpecialInfo = _resolveComponent("CourseSpecialInfo")!
  const _component_CourseEnrollmentStatus = _resolveComponent("CourseEnrollmentStatus")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.shown,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shown) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      (_ctx.course)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "modal-close-button",
                    "aria-label": "Schließen",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
                  }, _hoisted_7)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Popper, {
                      hover: true,
                      arrow: true
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _hoisted_13,
                          _hoisted_14,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descriptionLines, (line) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: line }, [
                              _createElementVNode("span", null, _toDisplayString(line), 1),
                              _hoisted_15
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _createElementVNode("b", _hoisted_11, _toDisplayString(_ctx.course.course_type.name), 1),
                          _hoisted_12
                        ])
                      ]),
                      _: 1
                    }),
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.course.mode === 0 ? 'Offener Kurs' : 'Geschlossener Kurs'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.course.weekday_label) + ", " + _toDisplayString(_ctx.formatTime(_ctx.course.start_hours, _ctx.course.start_minutes)) + " – " + _toDisplayString(_ctx.formatTime(_ctx.course.end_hours, _ctx.course.end_minutes)) + " Uhr ", 1)
                  ]),
                  (_ctx.course.mode === 1 && (_ctx.course?.appointment_first || (_ctx.appointments && _ctx.appointments.length > 0)))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateWithDayLabel(_ctx.course?.appointment_first?.start || _ctx.appointments[0].start)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.course.mode === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (_ctx.loadingAppointments)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_23,
                              _hoisted_24
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.appointments.length) + " Kurstermine", 1),
                              _hoisted_25,
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAppointments && _ctx.toggleAppointments(...args)), ["prevent"]))
                              }, [
                                _hoisted_26,
                                _createTextVNode(" " + _toDisplayString(_ctx.showAppointments ? 'verstecken' : 'anzeigen'), 1)
                              ])
                            ], 64)),
                        (_ctx.showAppointments)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("ol", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointments, (appointment) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: appointment.id
                                  }, _toDisplayString(_ctx.formatDatetimeWithDayLabel(appointment.start)), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.course.mode === 1 && _ctx.course.enrollment_deadline)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _hoisted_29,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDatetimeWithDayLabel(_ctx.course.enrollment_deadline)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.course.mode === 1 && _ctx.course.withdrawal_deadline)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _hoisted_31,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDatetimeWithDayLabel(_ctx.course.withdrawal_deadline)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  (_ctx.course.fee)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _createTextVNode(" " + _toDisplayString(_ctx.currencyFormatter.format(_ctx.course.fee / 100)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.course.location?.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _hoisted_36,
                        _createTextVNode(" " + _toDisplayString(_ctx.course.location?.name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createTextVNode(" " + _toDisplayString(_ctx.course.gathering_name), 1)
                  ]),
                  (_ctx.course.info_bringalong)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.course.info_bringalong), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.course.info_text)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createTextVNode(" " + _toDisplayString(_ctx.course.info_text), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_CourseSpecialInfo, {
                  course: _ctx.course,
                  classes: "mb-5"
                }, null, 8, ["course"])
              ]),
              _createVNode(_component_CourseEnrollmentStatus, {
                "course-id": _ctx.course.id,
                "region-id": _ctx.course.region_id,
                onEnrollmentStatusChange: _ctx.onEnrollmentStatusChange
              }, null, 8, ["course-id", "region-id", "onEnrollmentStatusChange"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}